import React, { useEffect, useState } from "react";
import { LogOut, Menu, Search, Settings, User2 } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";

//import images
import userProfile from "assets/images/users/user-profile.png";
import logoSm from "assets/images/users/user-profile.png";
import logoDark from "assets/images/users/user-profile.png";
import logoLight from "assets/images/users/user-profile.png";

//import components
import LightDark from "Common/LightDark";
import NotificationDropdown from "Common/NotificationDropdown";
import { Dropdown } from "Common/Components/Dropdown";
import { changeLeftsidebarSizeType } from "slices/thunk";
import { toast } from "react-toastify";
import { getRoleId, getUsername } from "Common/Components/getRoleId";

const pageTranslations = {
  "عرضه دان": "ChickensAndDan",
  ناظر: "supervisor",
  "کارخانه تولید دان": "production-factory",
  "مرغ دار": "chicken-page",
  "ثبت استان": "ProvincialRegistration",
  "ثبت شهرستان": "CityRegiste",
  "ثبت واحد اندازه گیری": "Measurementpage",
  کنسانتره: "ConcentrateInalizepage",
  تنظیمات: "user-profile",
  کاربران: "manageUser",
  "دان و جوجه عرضه شده": "ChickensAndDanWith-Chicken",
  سویا: "DanMesh/Soybean",
  ذرت: "DanMesh/Corn",
  روغن: "DanMesh/Oil",
  "دی‌کلسیم فسفات ": "DanMesh/DicalciumPhosphate",
  " مونوکلسیم فسفات": "DanMesh/MonocalciumPhosphate",
  "کربنات کلسیم": "DanMesh/CalciumCarbonate",
  "کولین کلراید": "DanMesh/CholineChloride",
  متیونین: "DanMesh/Methionine",
  لیزین: "DanMesh/Lysine",
  والین: "DanMesh/Valine",
  ایزولوسین: "DanMesh/Isoleucine",
  آرژنین: "DanMesh/Arginine",
  "جوش شیرین": "DanMesh/SodiumBicarbonate",
  فیتاز: "DanMesh/Phytase",
  پروبیوتیک: "DanMesh/Probiotic",
  "ضد قارچ": "DanMesh/Antifungal",
};

const Header = ({ handleToggleDrawer, handleDrawer }: any) => {
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const token = localStorage.getItem("app_havir");
  const [username, setusername] = useState<any>(null);
  const role = getRoleId(token);
  const roleNames: Record<number, string> = {
    1: "مدیر",
  };
  const [query, setQuery] = useState("");
  useEffect(() => {
    setusername(getUsername(token));
  }, [token]);

  // react-redux
  const selectLayoutState = (state: any) => state.Layout;
  const selectLayoutProperties = createSelector(
    selectLayoutState,
    (layout: any) => ({
      layoutSidebarSizeType: layout.layoutSidebarSizeType,
      layoutType: layout.layoutType,
    })
  );

  const handleSearch = () => {
    if (query.trim()) {
      const matchedEntry = Object.entries(pageTranslations).find(([key]) =>
        key.includes(query.trim())
      );
      if (matchedEntry) {
        setQuery("");
        const [, translatedPage] = matchedEntry;
        navigate(`/${translatedPage}`);
      } else {
        toast.error("صفحه موردنظر یافت نشد! 404 ");
      }
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  const { layoutSidebarSizeType, layoutType } = useSelector(
    selectLayoutProperties
  );

  const handleTopbarHamburgerIcon = () => {
    var windowSize = document.documentElement.clientWidth;
    let sidebarOverlay = document.getElementById("sidebar-overlay") as any;

    if (windowSize < 768) {
      document.body.classList.add("overflow-hidden");
      if (sidebarOverlay.classList.contains("hidden")) {
        sidebarOverlay.classList.remove("hidden");
        (document as Document | any)
          .querySelector(".app-menu")
          .classList.remove("hidden");
      } else {
        sidebarOverlay.classList.add("hidden");
        (document as Document | any)
          .querySelector(".app-menu")
          .classList.add("hidden");
      }
      dispatch(changeLeftsidebarSizeType("lg"));
    } else {
      dispatch(
        changeLeftsidebarSizeType(layoutSidebarSizeType === "sm" ? "lg" : "sm")
      );
    }
  };

  useEffect(() => {
    // resize
    const handleResizeLayout = () => {
      var windowSize = document.documentElement.clientWidth;

      if (windowSize < 768) {
        dispatch(changeLeftsidebarSizeType("lg"));
      } else if (windowSize <= 1024) {
        if (layoutType === "vertical") {
          dispatch(changeLeftsidebarSizeType("sm"));
        } else {
          dispatch(changeLeftsidebarSizeType("lg"));
        }
      } else {
        dispatch(changeLeftsidebarSizeType("lg"));
      }
    };

    // out side click
    const outerSideElement = () => {
      var windowSize = document.documentElement.clientWidth;
      var sidebarOverlay = document.getElementById("sidebar-overlay") as any;
      if (sidebarOverlay) {
        sidebarOverlay.addEventListener("click", () => {
          if (!sidebarOverlay.classList.contains("hidden")) {
            if (windowSize <= 768) {
              document?.querySelector(".app-menu")?.classList.add("hidden");
              document.body.classList.remove("overflow-hidden");
              sidebarOverlay.classList.add("hidden");
            } else {
              dispatch(changeLeftsidebarSizeType("lg"));
            }
          }
        });
      }
    };

    // scroll
    const scrollNavigation = () => {
      var scrollUp = document.documentElement.scrollTop;
      if (scrollUp >= 50) {
        document.getElementById("page-topbar")?.classList.add("is-sticky");
      } else {
        document.getElementById("page-topbar")?.classList.remove("is-sticky");
      }
    };

    window.addEventListener("scroll", scrollNavigation, true);
    window.addEventListener("click", outerSideElement);
    window.addEventListener("resize", handleResizeLayout);

    return () => {
      window.removeEventListener("scroll", scrollNavigation, true);
      window.removeEventListener("click", outerSideElement);
      window.removeEventListener("resize", handleResizeLayout);
    };
  }, [layoutType, dispatch]);


  return (
    <React.Fragment>
      <header
        id="page-topbar"
        className={`
          fixed right-0 left-0 top-0 z-[1000] transition-all duration-300
          bg-white/90 backdrop-blur-sm border-b border-gray-200
          dark:bg-gradient-to-r dark:from-gray-900 dark:to-gray-800 dark:backdrop-blur-none dark:border-gray-700
          ltr:md:left-vertical-menu rtl:md:right-vertical-menu
          group-data-[sidebar-size=md]:ltr:md:left-vertical-menu-md group-data-[sidebar-size=md]:rtl:md:right-vertical-menu-md
          group-data-[sidebar-size=sm]:ltr:md:left-vertical-menu-sm group-data-[sidebar-size=sm]:rtl:md:right-vertical-menu-sm
          group-data-[layout=horizontal]:ltr:left-0 group-data-[layout=horizontal]:rtl:right-0
          print:hidden group-data-[navbar=hidden]:hidden group-data-[navbar=scroll]:absolute
          group/topbar group-data-[layout=horizontal]:z-[1004]
        `}
      >
        <div className="layout-width">
          <div className="flex items-center px-4 mx-auto h-header shadow-none border-0">
            <div className="flex items-center w-full group-data-[layout=horizontal]:mx-auto group-data-[layout=horizontal]:max-w-screen-2xl navbar-header gap-4">
              {/* لوگو - بدون تغییر */}
              <div className="items-center justify-center hidden px-2 text-center h-header group-data-[layout=horizontal]:md:flex">
                <Link to="/">
                  <span className="hidden">
                    <img src={logoSm} alt="" className="h-6 mx-auto" />
                  </span>
                  <span className="group-data-[topbar=dark]:hidden group-data-[topbar=brand]:hidden">
                    <img src={logoDark} alt="" className="h-6 mx-auto" />
                  </span>
                </Link>
                <Link
                  to="/"
                  className="hidden group-data-[topbar=dark]:block group-data-[topbar=brand]:block"
                >
                  <span className="group-data-[topbar=dark]:hidden group-data-[topbar=brand]:hidden">
                    <img src={logoSm} alt="" className="h-6 mx-auto" />
                  </span>
                  <span className="group-data-[topbar=dark]:block group-data-[topbar=brand]:block">
                    <img src={logoLight} alt="" className="h-6 mx-auto" />
                  </span>
                </Link>
              </div>

              {/* منوی همبرگری */}
              <Menu
                onClick={handleTopbarHamburgerIcon}
                className="hidden lg:flex w-7 h-7 cursor-pointer text-gray-700 dark:text-gray-200 transition-transform hover:scale-110 hover:text-blue-500 dark:hover:text-blue-400"
                strokeWidth={1.5}
              />

              {/* جستجو */}
              <div className="relative hidden md:block group-data-[layout=horizontal]:hidden group-data-[layout=horizontal]:lg:block">
                <div className="relative">
                  <input
                    type="text"
                    className="w-full md:w-[300px] lg:w-[360px] py-2.5 pr-10 pl-12 text-sm rounded-full border focus:outline-none focus:ring-2 focus:ring-blue-500/20
                      bg-gray-100 border-gray-200 text-gray-800 placeholder:text-gray-500
                      dark:bg-gray-800 dark:border-gray-700 dark:text-gray-200 dark:placeholder:text-gray-400"
                    placeholder="جستجوی صفحه..."
                    autoComplete="off"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    onKeyDown={handleKeyDown}
                  />
                  <Search
                    onClick={handleSearch}
                    className="absolute left-3 top-1/2 -translate-y-1/2 size-5 cursor-pointer text-gray-500 hover:text-blue-500 transition-colors dark:text-gray-400 dark:hover:text-blue-400"
                  />
                </div>
              </div>

              <div className="flex gap-2 ms-auto items-center">
                <div className="transform transition-transform hover:scale-105">
                  <LightDark />
                </div>

                <NotificationDropdown />

                <div className="relative items-center hidden h-header md:flex">
                  <button
                    onClick={handleToggleDrawer}
                    type="button"
                    className="inline-flex justify-center items-center w-9 h-9 rounded-full text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800 transition-all duration-200"
                  >
                    <Settings className="size-5" strokeWidth={1.5} />
                  </button>
                </div>

                {/* منوی کاربری */}
                <Dropdown className="relative flex items-center h-header">
                  <Dropdown.Trigger
                    type="button"
                    className="flex items-center gap-2 p-1 rounded-full transition-all duration-200 hover:bg-gray-100 dark:hover:bg-gray-800 group"
                    id="dropdownMenuButton"
                  >
                    <div className="flex items-center gap-2">
                      <span className="text-sm font-medium text-gray-700 dark:text-gray-200">
                        {username === "admin" ? "مدیر" : username}
                      </span>
                      <div className="relative transition-transform hover:scale-105">
                        <img
                          src={userProfile}
                          alt="avatar"
                          className="size-10 rounded-full object-cover border-2 border-white dark:border-gray-700 shadow-sm"
                        />
                        <span className="absolute bottom-0 right-0 block size-2.5 rounded-full bg-green-500 ring-2 ring-white dark:ring-gray-800"></span>
                      </div>
                    </div>
                  </Dropdown.Trigger>
                  <Dropdown.Content
                    placement="right-end"
                    className="absolute z-50 p-4 ltr:text-left rtl:text-right bg-white/95 backdrop-blur-md rounded-2xl shadow-xl !top-4 dropdown-menu min-w-[16rem] dark:bg-gray-800/95 border border-gray-100 dark:border-gray-700"
                    aria-labelledby="dropdownMenuButton"
                  >
                    <div className="mb-4 text-center border-b border-gray-100 dark:border-gray-700 pb-3">
                      <h6 className="text-sm font-medium text-slate-500 dark:text-gray-400">
                        به پایش آرد خوش آمدید
                      </h6>
                    </div>
                    <div className="flex gap-4 mb-4 p-2 rounded-xl bg-gray-50 dark:bg-gray-700/50">
                      <div className="shrink-0">
                        <img src={userProfile} alt="" className="size-14 rounded-full" />
                      </div>
                      <div>
                        <h6 className="text-base font-semibold text-gray-800 dark:text-white">
                          {username || "مدیر سیستم"}
                        </h6>
                        {role && roleNames[role] && (
                          <p className="text-sm text-slate-500 dark:text-gray-400">{roleNames[role]}</p>
                        )}
                      </div>
                    </div>
                    <ul className="space-y-1">
                      <li>
                        <Link
                          to="/user-profile"
                          className="flex items-center gap-3 px-3 py-2 rounded-xl text-gray-700 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-gray-700 transition-all"
                        >
                          <User2 size={18} /> پروفایل
                        </Link>
                      </li>
                      <li className="pt-2 mt-1 border-t border-gray-100 dark:border-gray-700">
                        <Link
                          to="/logout"
                          className="flex items-center gap-3 px-3 py-2 rounded-xl text-red-600 hover:bg-red-50 dark:hover:bg-red-900/20 transition-all"
                        >
                          <LogOut size={18} /> خروج از سیستم
                        </Link>
                      </li>
                    </ul>
                  </Dropdown.Content>
                </Dropdown>
              </div>
            </div>
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};



export default Header;